// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BtnPostuler_wrapper__2y43X","arrow":"BtnPostuler_arrow__1eWhj"};